import { NEUROID_SCRIPT_URL } from '../../env';

const NEUROID_COLLECTION_SITE_ID = 'form_solos447';

type NeuroIdCommand = 'setLinkedSiteId' | 'identify' | 'applicationSubmit' | 'closeSession';

type NeuroIdFunction = {
  (command: NeuroIdCommand, value?: string): void;
  q?: unknown[]; // queue for commands called before script load; processed once the script actually initializes
  getUserId?: () => string;
};

type NeuroIdWindow = {
  nid?: NeuroIdFunction;
} & Window;

/**
 * Loads the NeuroID JavaScript library.
 *
 * This is the exact snippet from NeuroID documentation, wrapped in a function:
 * https://neuro-id.readme.io/docs/installation-account-opening
 *
 * <script type="text/javascript">
 *   (function(n,e,u,r,o,i,d){
 *       n.nid=n.nid||function(){(n.nid.q=n.nid.q||[]).push(arguments)};
 *       o=e.createElement(u);i=e.getElementsByTagName(u)[0];o.async=1;
 *       o.src=r;i.parentNode.insertBefore(o,i);
 *   })(window,document,'script','//scripts.neuro-id.com/c/nid-SITEID.js');
 * </script>
 */
const loadScript = (): void => {
  /* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-explicit-any, prefer-rest-params */
  (function (n, e, u, r, o, i) {
    n.nid =
      n.nid ||
      function () {
        (n.nid.q = n.nid.q || []).push(arguments);
      };

    o = e.createElement(u);
    i = e.getElementsByTagName(u)[0];
    o.async = 1;
    o.src = r;
    i.parentNode!.insertBefore(o, i);
  })(window as any, document, 'script', NEUROID_SCRIPT_URL, undefined as any, undefined as any);
  /* eslint-enable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-explicit-any, prefer-rest-params */
};

const setLinkedSiteId = (): void => {
  const win = window as NeuroIdWindow;
  win.nid?.('setLinkedSiteId', NEUROID_COLLECTION_SITE_ID);
};

const identify = (identityId: string): void => {
  const win = window as NeuroIdWindow;
  win.nid?.('identify', identityId);
};

export { loadScript, setLinkedSiteId, identify };
